module.exports = __webpack_public_path__ + "static/media/icon_inbox_REPSE.6f3cbc6a.svg";